import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function EstudantesNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Estudantes+%E2%80%94+menu+superior+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Entrar na AAPEQ
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Estudantes+%E2%80%94+menu+mobile+%E2%80%94+Quero+entrar+na+AAPEQ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Entrar na AAPEQ
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function EstudantesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <EstudantesNavbar />

      {/* Banner */}
      <div className="relative w-full h-[260px] sm:h-[300px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/2dd46a9f522463f624fa906e7d787edf.jpg"
          alt="Estudantes & Jovens AAPEQ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Estudantes & Jovens
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Estudantes & Jovens — AAPEQ
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-3 max-w-xl">
            Foco, direção, maturidade emocional e potência interna para o futuro
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              A AAPEQ oferece um processo exclusivo para estudantes do ensino fundamental II, ensino médio e ensino superior, ampliando foco, disciplina, consciência emocional, organização interna e direção real de carreira.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              A formação trabalha diretamente a mente, emoção e energia do estudante, criando jovens mais fortes, conscientes e preparados para decisões importantes.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-graduation-cap-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Quem Pode Participar</h2>
            </div>
            <div className="grid sm:grid-cols-3 gap-4 mb-6">
              <div className="bg-white p-5 rounded-xl">
                <h3 className="text-base font-bold text-[#262364] mb-3">Ensino Fundamental – Anos Finais</h3>
                <div className="space-y-2">
                  {['6º ano', '7º ano', '8º ano', '9º ano'].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#F05954] flex-shrink-0"></span>
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white p-5 rounded-xl">
                <h3 className="text-base font-bold text-[#262364] mb-3">Ensino Médio</h3>
                <div className="space-y-2">
                  {['1º ano', '2º ano', '3º ano'].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#F05954] flex-shrink-0"></span>
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white p-5 rounded-xl">
                <h3 className="text-base font-bold text-[#262364] mb-3">Ensino Superior</h3>
                <div className="space-y-2">
                  {['Graduação', 'Tecnólogo', 'Cursos de formação profissional'].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#F05954] flex-shrink-0"></span>
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-[#262364] text-white p-5 rounded-xl text-center">
              <p className="text-base font-semibold">A AAPEQ trabalha com estudantes a partir do 7º ano.</p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que É Trabalhado no Estudante AAPEQ</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                'Foco e disciplina mental',
                'Organização interna e estabilidade emocional',
                'Clareza acadêmica e aumento do aproveitamento',
                'Resolução de questões emocionais e inseguranças',
                'Direcionamento de carreira e identidade pessoal',
                'Solução de conflitos familiares e sociais',
                'Quebra de vícios e padrões destrutivos',
                'Maturidade emocional para escolhas importantes',
                'Blindagem emocional para ambiente escolar',
                'Saúde vibratória e força interna'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gradient-to-br from-[#262364] to-[#1a1845]">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-8 h-8 rounded-full bg-white"></div>
              <div className="w-8 h-8 rounded-full bg-black"></div>
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-white mb-4">YIN YANG — Feminino e Masculino</h2>
            <p className="text-base text-white/90 leading-relaxed max-w-3xl mx-auto">
              Potencialização de conflitos societários, sexualidade, conexão com o seu sagrado pessoal
            </p>
            <p className="text-base text-white/80 leading-relaxed max-w-3xl mx-auto mt-4">
              Esse entendimento trabalha a estrutura interna do jovem, ampliando consciência, equilíbrio e força para tomada de decisões reais.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">A Evolução do Estudante na AAPEQ</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">O jovem desenvolve:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {[
                'Maturidade emocional',
                'Foco contínuo',
                'Disciplina aplicada',
                'Consciência do sentir',
                'Clareza de objetivos',
                'Presença e confiança',
                'Força interna para decisões difíceis',
                'Equilíbrio social e familiar',
                'Organização emocional e mental',
                'Estabilidade sob pressão'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Técnicas Aplicadas</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                'Protocolos telepáticos avançados',
                'Organização vibratória para foco',
                'Verdade no sentir',
                'Ação perfeita',
                'Estado Zero para estudo',
                'Blindagem emocional jovem',
                'Consciência respiratória',
                'Disciplina comportamental'
              ].map((item, idx) => (
                <div key={idx} className="bg-white p-5 rounded-xl border-l-4 border-[#F05954]">
                  <div className="flex items-start gap-3">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    <span className="text-sm text-gray-700 font-medium">{item}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-bookmark-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Exigências</h2>
            </div>
            <div className="space-y-3">
              {[
                'Matriculado no 7º ano ou acima',
                'Ensino médio ou superior',
                'Comprovação simples (carteirinha, declaração ou print)',
                'Comprometimento real'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que É Trabalhado no Atleta AAPEQ</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3 mb-6">
              {[
                'Foco absoluto e clareza mental',
                'Estabilidade emocional em ambientes intensos',
                'Controle do estado interno antes, durante e após competições',
                'Forte presença comportamental',
                'Resistência vibratória e emocional',
                'Estruturação de foco para tomada de decisão',
                'Organização do ritmo interno e respiratório',
                'Blindagem emocional para evitar quedas e instabilidades',
                'Ação perfeita em momentos críticos',
                'Controle energético e direcionamento em ambientes competitivos',
                'Reestruturação emocional após treinos ou derrotas'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="space-y-4">
              {[
                { icon: 'ri-heart-pulse-line', title: 'Regeneração Celular (processo técnico-energético)', desc: 'Organização do estado interno para favorecer recuperação, vitalidade e acelerar processos naturais do corpo — sem alegações médicas.' },
                { icon: 'ri-shield-cross-line', title: 'Tratamento e Prevenção de Lesões (processo comportamental & vibratório)', desc: 'Protocolos de consciência corporal, foco, preparo mental e ajuste de estado interno que auxiliam o atleta a evitar padrões repetitivos de queda e tensão.' },
                { icon: 'ri-shield-check-line', title: 'Bloqueio de Lesões Energéticas (proteção comportamental & vibratória)', desc: 'Trabalho interno para minimizar colapsos emocionais que favorecem distrações e impactos negativos.' },
                { icon: 'ri-brain-line', title: 'Fortalecimento Telepático e Mental', desc: 'Leitura rápida de intenção, ritmo do oponente, foco de equipe, ambiente emocional — técnica profissional.' },
                { icon: 'ri-shield-star-line', title: 'Proteção Magnética Interna', desc: 'Blindagem emocional e vibratória para manter foco mesmo sob pressão, hostilidade ou ansiedade.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-white p-5 rounded-xl border-l-4 border-[#F05954]">
                  <h3 className="text-base font-bold text-[#262364] mb-2 flex items-start gap-2">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed pl-5">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-line-chart-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">A Evolução do Atleta na AAPEQ</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">O atleta evolui em múltiplos níveis:</p>
            <div className="space-y-4">
              {[
                { icon: 'ri-user-settings-line', title: 'Maior controle da vida pessoal', desc: 'Organização interna que melhora tomada de decisões, rotina e disciplina.' },
                { icon: 'ri-emotion-line', title: 'Evolução emocional consistente', desc: 'Adaptação emocional para ambientes competitivos e sociais.' },
                { icon: 'ri-compass-3-line', title: 'Direcionamento e foco dos objetivos do EU', desc: 'Clareza no porquê, para quê, e como executar cada fase da carreira.' },
                { icon: 'ri-heart-3-line', title: 'Clareza dos próprios sentires', desc: 'Consciência do que sente, como sente e como transformar isso em força.' },
                { icon: 'ri-mental-health-line', title: 'Cura de medos e inseguranças', desc: 'Reestruturação emocional que traz confiança, firmeza e segurança na execução.' },
                { icon: 'ri-contrast-2-line', title: 'Aumento da polaridade masculina e feminina', desc: 'Equilíbrio interno das duas energias fundamentais: força, decisão e direção (polaridade masculina) e presença, sensibilidade e percepção (polaridade feminina). Esse equilíbrio resulta em atletas mais completos, estáveis e confiantes.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gray-50 p-5 rounded-xl">
                  <h3 className="text-base font-bold text-[#262364] mb-2 flex items-center gap-2">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed pl-5">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-settings-3-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Técnicas Aplicadas ao Atleta</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">Cláudio SAN aplica técnicas objetivas de alta performance:</p>
            <div className="space-y-4">
              {[
                { title: 'Protocolos Telepáticos Avançados', desc: 'Leitura vibratória do oponente, percepção de intenção e ajuste imediato do foco.' },
                { title: 'Capacitação Motora e Foco Combatente', desc: 'Aprimoramento de prontidão, tempo interno, ritmo e controle.' },
                { title: 'Energia Interna Aplicada à Performance', desc: 'Gestão do estado vibratório para manter clareza durante desgaste extremo.' },
                { title: 'Estado Zero para Decisão Rápida', desc: 'Neutralidade emocional → clareza → ação perfeita.' },
                { title: 'Blindagem Mental Competitiva', desc: 'Resistência emocional a provocações, fracassos, pressão externa.' },
                { title: 'Ritmo Respiratório Estratégico', desc: 'Organização da respiração para desempenho prolongado.' },
                { title: 'Verdade no Sentir Esportivo', desc: 'Controle emocional para não colapsar durante treinos ou competições.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-white p-5 rounded-xl border-l-4 border-[#F05954]">
                  <h3 className="text-base font-bold text-[#262364] mb-2 flex items-start gap-2">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed pl-5">{item.desc}</p>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-5 rounded-xl mt-6 text-center">
              <p className="text-base font-semibold">
                Resultado: Atletas mais fortes, conscientes, estáveis, rápidos e estrategistas.
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-bookmark-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Exigências para Entrar</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-4">Obrigatório comprovar atuação real como atleta:</p>
            <div className="space-y-3 mb-6">
              {[
                'Competidor federado ou amador avançado',
                'Trajetória ativa em competições, treinos ou equipe',
                'Treinar com frequência e constância',
                'Vídeos, fotos, links oficiais, currículo ou comprovação prática'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#F05954] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold mb-2">Para artes marciais:</p>
              <div className="space-y-1">
                {['Competidores: a partir da faixa roxa', 'Mestres: faixa preta', 'Professores: comprovação de aula ativa'].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-focus-3-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Para Quem É Este Processo</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                'Atletas olímpicos',
                'Atletas profissionais e semi-profissionais',
                'Lutadores',
                'Corredores e maratonistas',
                'Jogadores de futebol, vôlei, basquete',
                'Ginastas',
                'Triatletas',
                'Competidores de alto rendimento',
                'Professores e treinadores esportivos'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-6">
              Quer desenvolver foco, disciplina e direção real para o futuro?
            </h2>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Estudantes+%E2%80%94+CTA+final+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-6 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Entrar na AAPEQ — Estudantes
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
